module.exports = __webpack_public_path__ + "img/mgh-kyobashi-sp.7ea819e5.jpg";